import { useMemo } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { AppTheme, Colors } from 'styles/theme';
import { useTranslation } from 'react-i18next';
import useDepsContainer from 'hooks/useDepsContainer';
import Flex from 'components/common/Flex';
import FreelowSwiper from './FreelowSwiper';

const Freelows = () => {
  const history = useHistory();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const styles = useStyles({ mdDown });
  const { uiStore } = useDepsContainer();
  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);

  return (
    <Flex className={styles.content} width={mdDown ? '100vw' : '100%'} id={''} column>
      <p className={mdDown ? styles.h1Md : styles.h1}>
        {cachedT('freeFlowFinance')}
        <em></em>
      </p>
      {(mdDown || lgDown) && <FreelowSwiper />}
      {!mdDown && !lgDown && (
        <Flex mt={10}>
          <Flex width={410} mr={6} className={styles.steps} column>
            <Flex pt={10} mb={2} className={styles.stepsCard} column>
              <h2>{cachedT('forMatchmakers')}</h2>
              <img src="/images/home-freelows-1.webp" width={277} alt="" />
            </Flex>
            <div className={`${styles.overlay} ${'overlay'}`}></div>
            <div className={`${styles.stepText} ${'stepText'}`}>{cachedT('friendIntroductions')}</div>
          </Flex>
          <Flex width={410} mr={6} className={styles.steps} column>
            <Flex pt={10} mb={2} className={styles.stepsCard} column>
              <h2>{cachedT('forLadiesAndGentlemen')}</h2>
              <img src="/images/home-freelows-2.webp" width={279} alt="" />
            </Flex>
            <div className={`${styles.overlay} ${'overlay'}`}></div>
            <div className={`${styles.stepText} ${'stepText'}`}>
              <ul className={styles.stepsUl} style={{ paddingLeft: '16px', textAlign: 'left' }}>
                <li>{cachedT('exclusiveSecretContent')}</li>
                <li>{cachedT('earnPumpkinFavorites')}</li>
                <li>{cachedT('instantFavoriteResponse')}</li>
                <li>{cachedT('giftSendingOptions')}</li>
              </ul>
            </div>
          </Flex>
          <Flex width={410} className={styles.steps} column>
            <Flex pt={10} mb={2} className={styles.stepsCard} column>
              <h2>{cachedT('forEveryone')}</h2>
              <img src="/images/home-freelows-3.webp" width={277} alt="" />
            </Flex>
            <div className={`${styles.overlay} ${'overlay'}`}></div>
            <div className={`${styles.stepText} ${'stepText'}`}>{cachedT('reputationVoting')}</div>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    content: {
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'center',
      color: 'black',
      maxWidth: '1280px'
    },
    h1: {
      width: '100%',
      // height: '84px',
      //background: 'url(/images/home-freelows-header.svg) center no-repeat'
      color: '#18181B',
      fontFamily: 'Lexend',
      fontSize: '64px',
      fontWeight: '900',
      lineHeight: '78px',
      letterSpacing: '-1px',
      textAlign: 'center',
      margin: '40px auto',

      '& em': {
        display: 'inline-block',
        width: '80px',
        height: '80px',
        background: 'url(images/title-icon5.svg) left no-repeat',
        backgroundSize: '80px 80px',
        marginBottom: '-20px'
      }
    },
    h1Md: {
      width: 'calc(100% - 32px)',
      // height: '96px',
      color: '#18181B',
      fontFamily: 'Lexend',
      fontSize: '40px',
      fontWeight: '900',
      lineHeight: '48px',
      letterSpacing: '-1px',
      textAlign: 'center',
      margin: '24px auto',

      '& em': {
        display: 'inline-block',
        width: '40px',
        height: '40px',
        background: 'url(images/title-icon5.svg) left no-repeat',
        backgroundSize: '40px 40px',
        marginBottom: '-10px'
      }
    },
    steps: {
      borderRadius: '16px 16px 0px 0px',
      border: '8px solid #000',
      background: '#FFF',
      position: 'relative',
      cursor: 'pointer',

      '& h2': {
        fontSize: 24,
        color: '#18181B',
        fontWeight: 500,
        letterSpacing: '-0.5px',
        background: 'white',
        padding: '10px',
        lineHeight: '32px',
        marginBottom: '16px'
      },
      '& img': {
        // marginRight: '-30px'
        marginBottom: '-10px'
      },

      '&:hover': {
        '& .overlay': {
          display: 'block'
        },
        '& .stepText': {
          display: 'block'
        }
      }
    },
    stepsUl: {
      listStyleType: 'disc',
      '& li': {
        fontSize: '16px',
        marginBottom: '10px'
      }
    },
    stepsCard: {
      width: '100%',
      background: '#FFF',
      alignItems: 'center',
      borderRadius: '16px 16px 0px 0px',
      paddingTop: '40px'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 14.06%, rgba(15, 15, 15, 0.54) 47.4%, #1C1C1C 87.5%)',
      display: 'none'
    },
    stepText: {
      color: '#FFF',
      textAlign: 'center',
      fontSize: '16px',
      fontWeight: '300',
      lineHeight: '20px',
      width: '320px',
      position: 'absolute',
      bottom: '64px',
      left: '50%',
      marginLeft: '-160px',
      display: 'none'
    }
  })
);

export default observer(Freelows);
